import { Injectable } from '@angular/core';
import { CanvasDTO, CardDTO } from '@shared/dtos';
import { Firestore, addDoc, collection, doc, deleteDoc, setDoc } from '@angular/fire/firestore';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CanvasServiceBackend {
    private readonly TABLE = "canvas";
    
    constructor(private firestore: Firestore, private angularFirestore: AngularFirestore) { }

    public getCanva(id: string): Observable<CanvasDTO> {
      return this.angularFirestore.collection<CanvasDTO>(this.TABLE).doc(id).valueChanges().pipe(
        map(canva => {
            const cardsDTO = canva.cards.map(card => new CardDTO(card.title, card.data, card.description, card.descriptionItems,card.backgroundColor));
            return new CanvasDTO(canva.title,canva.idDoctor, canva.date, canva.trusted, cardsDTO, canva.id);
        })
      );
    }
    
    public getDoctorCanvas(idDoctor: string): Observable<CanvasDTO[]> {
      return this.angularFirestore.collection<CanvasDTO>(this.TABLE, ref => ref.where('idDoctor', '==', idDoctor))
        .snapshotChanges()
       .pipe(
          map(response => response.map(a => {
            const canva = a.payload.doc.data() as CanvasDTO;
            const id = a.payload.doc.id;
            return new CanvasDTO(canva.title, canva.idDoctor, canva.date, canva.trusted, canva.cards, id);
          }))
      );
    }
    
    public createCanvas(canvas: CanvasDTO) {
      const placeRef = collection(this.firestore, this.TABLE);
      return addDoc(placeRef, canvas.getJSON());
    }

    public updateCanvas(canvas: CanvasDTO) {
      const placeDocRef = doc(this.firestore, `${this.TABLE}/${canvas.id}`);
      return setDoc(placeDocRef, canvas.getJSON());
    }

    public deleteCanvas(id: string) {
      const placeDocRef = doc(this.firestore, `${this.TABLE}/${id}`);
      return deleteDoc(placeDocRef);
    }
}